module.exports = __webpack_public_path__ + "static/media/vc.fc6aa8fe.svg";